import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import {
  freshChannelSessionEmail,
  peekChannelSignIn,
  safeChannelSignInNext,
} from '@/features/channel-dashboard/channel-sign-in';
import { ChannelSignInConfirmation } from '@/features/channel-dashboard/channel-sign-in-confirmation';

export const Route = createFileRoute('/channels/sign-in')({
  validateSearch: z
    .object({
      code: z.string().optional().catch(undefined),
      next: z.string().optional().catch(undefined),
    })
    .passthrough().parse,
  beforeLoad: async ({ search }) => {
    const next = safeChannelSignInNext(search.next);
    const email = await peekChannelSignIn(search.code);
    if (email === null || search.code === undefined) {
      throw redirect({ href: next, replace: true });
    }
    if (freshChannelSessionEmail() === email) {
      throw redirect({ href: next, replace: true });
    }
    return { code: search.code, email, next };
  },
  component: ChannelSignInConfirmationRoute,
});

function ChannelSignInConfirmationRoute() {
  const { code, email, next } = Route.useRouteContext();
  return (
    <ChannelSignInConfirmation
      code={code}
      currentEmail={freshChannelSessionEmail()}
      email={email}
      next={next}
    />
  );
}
